import { render, staticRenderFns } from "./InquiryDetailPopupIframe.vue?vue&type=template&id=33cd52bf&"
import script from "./InquiryDetailPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./InquiryDetailPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports